import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Header';
import CategoryNav from '../CategoryNav';
import Breadcrumb from './Breadcrumb';
import Sidebar from './Sidebar';
import Footer from '../Footersection';
const ProfilePage = () => {
  const location = useLocation();

  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const baseItems = ['Home', 'Profile'];

    if (pathSegments.length > 1) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      const pageNames = {
        'orders': 'Orders',
        'address': 'My Address',
        // 'add-address': 'My Address',
        'settings': 'Settings',
        
      };

      if (pageNames[lastSegment]) {
        baseItems.push(pageNames[lastSegment]);
      }
    }

    return baseItems;
  };

  return (
    <div >
      <Header />
      {/* <CategoryNav /> */}
       <div className="flex overflow-hidden flex-col items-center pb-12  bg-neutral-50 max-md:pb-24">
      <Breadcrumb navigationItems={getBreadcrumbItems()} />

      <div className="mt-7 w-full max-w-[1140px] max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col">
          <Sidebar />
      
          <Outlet />
          
        </div>
      </div>
      </div>
      
          <Footer/>
    </div>
  );
};

export default ProfilePage;
